import { onMessageFromWebApp } from "./webAppMessenger";
import { PERSIST_LOCALSTORAGE } from "./messageTypes";

// This is important for authentication on iOS
// When the app is force closed the localstorage contents from the iframe are deleted
// so we cache all the localstorage updates in the parent frame and restore them
// in the child frame when we are first starting up.
onMessageFromWebApp(PERSIST_LOCALSTORAGE, async ({ key, newValue }) => {
  if (newValue === null) {
    window.localStorage.removeItem(key);
  } else {
    window.localStorage.setItem(key, newValue);
  }
});
